import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import '../styles/Navigation.css';

const Navigation = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  
  const navItems = [ 
    { name: 'Home', href: '/' }, 
    { name: 'About Us', href: '/about' },
    { name: 'Activities', href: '/activities' },
    { name: 'Contact', href: '/contact' },
    { name: 'Rooms', href: '/rooms' },
    { name: 'How To Get There', href: '/how-to-get-there' }
  ];

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  return (
    <nav className="navigation">
      <button 
        className="mobile-menu-toggle" 
        onClick={toggleMenu}
        aria-label="Toggle menu"
      >
        <span className={`hamburger ${isMenuOpen ? 'open' : ''}`}>
          <span></span>
          <span></span>
          <span></span>
        </span>
      </button>
      <ul className={`nav-list ${isMenuOpen ? 'open' : ''}`}>
        {navItems.map((item) => (
          <li key={item.name} className="nav-item">
            <Link className="nav-link" to={item.href} onClick={closeMenu}>{item.name}</Link>
          </li>
        ))}
      </ul>
    </nav>
  );
};

export default Navigation;
